import {useUiStore} from "@/stores/ui.store.ts";

export default function GlobalLoader() {
  const loader = useUiStore(state => state.loader);
  if (!loader) {
    return null;
  }
  return (
    <div
      className="fixed top-0 h-screen w-full bg-white/70 backdrop-blur-none flex flex-col justify-center items-center"
      style={{zIndex: 999}}>
      <div className="flex items-center justify-center">
        <div
          className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current
          border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] text-foreground"
          role="status">
          <span
            className="absolute! -m-px! h-px! w-px! overflow-hidden! whitespace-nowrap! border-0! p-0! [clip:rect(0,0,0,0)]!">Loading...</span>
        </div>
      </div>
    </div>
  );
}